import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b227cf08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "campaign-complete",
  class: /*#__PURE__*/_normalizeClass({ portrait: true })
}
const _hoisted_2 = { id: "campaign-complete-info-container" }
const _hoisted_3 = { id: "campaign-complete-info" }
const _hoisted_4 = { id: "campaign-complete-info-summary-countdown-action" }

import BuyButton from '@/components/BuyButton.vue';
import Frame from '@/components/Frame.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimBuyOnlyBody',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, {
    id: "campaign-complete-frame",
    class: "m-project"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BuyButton)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})